import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Star, ArrowRight } from 'lucide-react';
import { getReferencePagesList } from '../utils/referencePages';

export default function ReferencePagesBanner({ project, className = '' }) {
  const navigate = useNavigate();
  const { slug } = useParams();
  const pages = getReferencePagesList(project);

  if (!pages.length) {
    return (
      <div
        className={`mb-6 p-4 rounded-xl border border-dashed border-accent/30 bg-accent/[0.04] flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 ${className}`}
      >
        <div className="flex items-start gap-3 min-w-0">
          <div className="w-9 h-9 rounded-lg bg-accent/10 flex items-center justify-center shrink-0">
            <Star size={18} className="text-accent" />
          </div>
          <div>
            <p className="text-sm font-semibold text-blue-gray-900">Pages de référence</p>
            <p className="text-sm text-blue-gray-600 mt-0.5">
              Requises pour PageSpeed, l&apos;audit visuel et le positionnement IA. Le SEO reste analysé sur tout le sitemap.
            </p>
          </div>
        </div>
        <button
          type="button"
          onClick={() => navigate(`/projects/${slug}/reference-pages`)}
          className="inline-flex items-center gap-1.5 text-sm font-medium text-accent hover:text-accent/80 shrink-0"
        >
          Configurer
          <ArrowRight size={16} />
        </button>
      </div>
    );
  }

  return (
    <div
      className={`mb-6 p-4 rounded-xl border border-accent/25 bg-gradient-to-r from-accent/[0.07] to-transparent flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 ${className}`}
    >
      <div className="flex items-start gap-3 min-w-0">
        <div className="w-9 h-9 rounded-lg bg-accent/15 flex items-center justify-center shrink-0">
          <Star size={18} className="text-accent fill-accent/20" />
        </div>
        <div className="min-w-0">
          <p className="text-sm font-semibold text-blue-gray-900">
            {pages.length} page{pages.length > 1 ? 's' : ''} de référence
          </p>
          <p className="text-xs text-blue-gray-600 mt-0.5">
            Performance, visuel et GEO · {pages.map((u) => u.replace(/^https?:\/\//, '')).join(' · ')}
          </p>
        </div>
      </div>
      <button
        type="button"
        onClick={() => navigate(`/projects/${slug}/reference-pages`)}
        className="inline-flex items-center gap-1.5 text-sm font-medium text-accent hover:text-accent/80 shrink-0"
      >
        Rapport détaillé
        <ArrowRight size={16} />
      </button>
    </div>
  );
}
